import { create } from "zustand";

export const useAdminStore = create((set) => ({
  actas: [],
  acta: null,
  estado_actas: 5,
  refetch: false,

  searchInspector: "all",
  filtroFecha: new Date().toISOString().split("T")[0],
  toggleFecha: false,
  asignarInspector: false,
  inspectores: null,
  inspectorAsignado: null,
  solicitudesAsignar: [],

  setSearchInspector: (inspector) => {
    set({ searchInspector: inspector });
  },
  setToggleFecha: (value) => {
    set({ toggleFecha: value });
  },

  setFiltroFecha: (value) => {
    set({ filtroFecha: value });
  },
  setEstadoActas: (estado) => {
    set({ estado_actas: estado });
  },

  setRefetch: (value) => {
    set({ refetch: value });
  },

  setActas: (actas) => {
    set({ actas: actas });
  },
  setActa: (acta) => {
    set({ acta: acta });
  },
  setInspectores: (inspectores) => {
    set({ inspectores: inspectores });
  },
  setAsignarInspector: (value) => {
    set({ asignarInspector: value });
  },
  setInspectorAsignado: (inspector) => {
    set({ inspectorAsignado: inspector });
  },
  setSolicitudesAsignar: (id) => {
    set((state) => {
      const yaExiste = state.solicitudesAsignar.includes(id);
      const nuevasSolicitudes = yaExiste
        ? state.solicitudesAsignar.filter((solicitudId) => solicitudId !== id)
        : [...state.solicitudesAsignar, id];

      return { solicitudesAsignar: nuevasSolicitudes };
    });
  },
  clearSoliciutdesAsignar: () => {
    set({ solicitudesAsignar: [] });
  },
}));
